<template>
    <NuxtLayout>
        <div>
            <NuxtPage />
        </div>
    </NuxtLayout>
    <DebugOverlay />
</template>
